export default __webpack_public_path__ + "static/alysha2-e9f351eb50af109ee5fc55731e4490f9.jpg";